var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"vertical highlight_list"},_vm._l((_vm.filteredHeroes),function(entry,index){return _c('li',{key:index},_vm._l((_vm.columns),function(key){return _c('span',{key:key,domProps:{"innerHTML":_vm._s(entry[key])},on:{"click":function($event){return _vm.getAreaCode(entry[key])}}})}),0)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44e7e989","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AreaCodeGrid.vue
// module id = null
// module chunks = 